import AButton from '@/components/A/AButton/AButton'
import styles from './ContactPagePc.module.less'
import { commonUtils } from '@/helpers/commonUtils'
import { message } from 'antd'
import copy from 'copy-to-clipboard'
import { Trans, useTranslation } from 'react-i18next'

function ContactPagePc() {
  const { t, i18n } = useTranslation()
  const email = 'Adeff@mininglamp.com'
  return (
    <div className={styles.contactPage} data-testid='contact-page'>
      <div className={styles.contactPageContent}>
        <div className={styles.card}>
          <img src={commonUtils.getImagePath('contactPage/contact-card-icon.png')} alt='' />
          <div className={styles.right}>
            <p className={styles.title}>{t('contact.title')}</p>
            <div className={styles.email}>{email}</div>
            <AButton
              testId='contact-copy-email-btn'
              style={{ marginTop: 32 }}
              type='primary'
              size='LGR'
              onClick={() => {
                copy(email)
                message.success(t('contact.message.success'))
              }}
            >
              {t('contact.copy')}
            </AButton>
          </div>
        </div>
        <p className={styles.belongDesc}>
          <a
            style={{ textDecoration: 'none', color: 'inherit' }}
            target='_blank'
            href={
              i18n.language === 'zh'
                ? 'https://www.mininglamp.com/'
                : 'https://www.mininglamp.com/en/'
            }
          >
            <Trans
              i18nKey='landing.footer.belongDesc'
              components={{ tmp: <span className={styles.corp} /> }}
            />
          </a>
        </p>
        <img
          className={styles.brand}
          src={commonUtils.getImagePath('homePage/minglue-adeff.png')}
          alt=''
        />
      </div>
    </div>
  )
}

export default ContactPagePc
